import { render, staticRenderFns } from "./FlashDeal.vue?vue&type=template&id=cbbcab02&scoped=true&"
import script from "./FlashDeal.vue?vue&type=script&lang=js&"
export * from "./FlashDeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbcab02",
  null
  
)

export default component.exports